module.exports = __webpack_public_path__ + "img/icon_user.946082df.svg";